import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { offerTypeFromJsonQuery } from '../../../packages/JsonQuery';

export const selectOfferType = createSelector(selectJsonQuery, jsonQuery => offerTypeFromJsonQuery(jsonQuery));
